<template>
  <div class="maintenance-task-card border rounded p-4 mb-3 bg-white">
    <div class="d-flex flex-wrap justify-content-between align-items-start">
      <div class="pr-4 mb-3 mb-md-0">
        <div class="font-weight-bolder text-dark font-size-lg">
          <a href="#" class="text-dark" @click.prevent="openClient">{{ task.clientName || "Unknown client" }}</a>
        </div>
        <div class="text-muted font-size-sm">
          <a href="#" class="text-dark-50 font-weight-bold" @click.prevent="openPolicy">{{ task.policyNumber }}</a>
          <span v-if="task.periodStart || task.periodEnd" class="mx-1">&middot;</span>
          <span v-if="task.periodStart || task.periodEnd">
            {{ formatDate(task.periodStart) }} to {{ formatDate(task.periodEnd) }}
          </span>
          <span v-if="task.premium != null" class="ml-2 font-weight-bold text-dark-50">
            {{ task.premium | currency("$", ",", 0, ".", "front", true) }}
            <span v-if="task.premiumHonesty" class="font-weight-normal text-warning">({{ task.premiumHonesty }})</span>
          </span>
        </div>
        <div class="mt-2">
          <span class="label label-inline label-light-warning font-weight-bold">{{ task.taskType }}</span>
        </div>
        <div v-if="task.blocker" class="mt-2 text-dark">{{ task.blocker }}</div>
      </div>
      <div class="d-flex flex-column align-items-stretch">
        <button
          v-if="task.primary && task.primary.label"
          class="btn btn-sm btn-primary font-weight-bold text-uppercase mb-2"
          @click.prevent="$emit('action', task, task.primary)"
        >
          {{ task.primary.label }}
        </button>
        <button
          v-if="task.secondary && task.secondary.label"
          class="btn btn-sm btn-light-primary font-weight-bold text-uppercase"
          @click.prevent="$emit('action', task, task.secondary)"
        >
          {{ task.secondary.label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";

export default {
  name: "MaintenanceTaskCard",
  props: {
    task: { type: Object, required: true }
  },
  methods: {
    formatDate(isoDate) {
      if (!isoDate) return "";
      return moment.tz(String(isoDate).slice(0, 10), "YYYY-MM-DD", "Australia/Sydney").format("DD/MM/YYYY");
    },
    openClient() {
      if (this.task.clientId) {
        this.$router.push(`/workbench/clients/${this.task.clientId}`).catch(() => {});
      }
    },
    openPolicy() {
      if (this.task.policyId) {
        this.$router.push(`/workbench/policies/${this.task.policyId}`).catch(() => {});
      }
    }
  }
};
</script>
